// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2a-1";
export var rateTableServiceLevelDropdown = "_2a-3";
export var rateTableTypeDropdown = "_2a-0";
export var rateTableValueModeDropdown = "_2a-2";